// Generated by purs version 0.15.16
var Fix = function (x) {
    return x;
};
var hmap = function (dict) {
    return dict.hmap;
};
var cata = function (dictHFunctor) {
    var hmap1 = hmap(dictHFunctor);
    return function (nat) {
        return function (v) {
            return nat(hmap1(cata(dictHFunctor)(nat))(v));
        };
    };
};
export {
    hmap,
    Fix,
    cata
};
//# sourceMappingURL=index.js.map
